import axios from '../../axios';
import {
  Skill,
  SkillCategory,
  CategoryFromAPI,
  SkillFromListAPI,
} from './skillsTypes.ts';

const toNumber = (value: string | number): number =>
  typeof value === 'string' ? parseInt(value, 10) : value;

const authConfig = () => {
  const token = localStorage.getItem('access-Token-Edify');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const fetchCategories = async (): Promise<SkillCategory[]> => {
  const { data } = await axios.get<CategoryFromAPI[]>('/skill/category/all', authConfig());
  return data.map((cat) => ({
    id: toNumber(cat.id),
    name: cat.name,
  }));
};

export const fetchSkillList = async (): Promise<Skill[]> => {
  const { data } = await axios.get<SkillFromListAPI[]>('/skill/list', authConfig());
  return (data || []).map((skill) => ({
    id: toNumber(skill.id),
    name: skill.name.charAt(0).toUpperCase() + skill.name.slice(1),
    categoryId: toNumber(skill.category?.id ?? 0),
  }));
};
